<template>
    <div class="main-wrapper">
        <bread-cumb/>
        <div class="two-tone-layout">
            <div class="equal-content-sidebar">
                <div class="container">
                    <right-info/>
                    <div class="content-wrapper">
                        <div class="mb-10"></div>
                        <success-box/>
                        <form id="paymentFormValid" method="get" action="#">
                            <billing-form/>
                            <room-form/>
                            <payment-form/>
                            <congrats-component/>
                        </form>
                        <div class="mb-40"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import breadCumb from '../components/billing/breadCumb'
    import rightInfo from '../components/billing/rightInfo'
    import successBox from '../components/billing/successBox'
    import billingForm from '../components/billing/billingForm'
    import roomForm from '../components/billing/roomForm'
    import paymentForm from '../components/billing/paymentForm'
    import congratsComponent from '../components/billing/congratsComponent'

    export default {
        name: "billing",
        components: {rightInfo, breadCumb, successBox, billingForm, roomForm, paymentForm, congratsComponent},
        comments: {
            breadCumb, rightInfo
        }
    }
</script>

<style scoped>

</style>